import { AppThunkAction } from "..";
import { KnownAction, ISocialMediaAnalysisHistory, REPIQ_SOCIAL_MEDIA_ANALYSIS_HISTORY, SHOW_LOADER } from "./types";
import * as services from "../service";

export const actionCreators = {
    getSocialMediaAnalysisHistory:
        (forceReload: boolean): AppThunkAction<KnownAction> =>
        (dispatch, getState) => {
            dispatch({ type: SHOW_LOADER, isLoading: true });
            const appState = getState();
            if (
                forceReload === false &&
                appState &&
                appState.repIQSocialMediaAnalysisHistoryState &&
                appState.repIQSocialMediaAnalysisHistoryState.socialMediaAnalysisHistory &&
                appState.repIQSocialMediaAnalysisHistoryState.socialMediaAnalysisHistory.length > 0
            ) {
                dispatch({ type: SHOW_LOADER, isLoading: false });
            } else {
                services
                    .getSocialMediaAnalysisHistory()
                    .then((data) => {
                        if (data && data.length > 0) {
                            let results: ISocialMediaAnalysisHistory[] = data as ISocialMediaAnalysisHistory[];

                            dispatch({ type: REPIQ_SOCIAL_MEDIA_ANALYSIS_HISTORY, socialMediaAnalysisHistory: results });
                        }
                        dispatch({ type: SHOW_LOADER, isLoading: false });
                    })
                    .catch(function (error) {
                        dispatch({ type: SHOW_LOADER, isLoading: false });
                    });
            }
        },
};
